export default "__VITE_ASSET__B$TMOLFk__"